"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext } from "react";
import { UserContext } from "@/contexts/user-provider";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
import { patchMyMeta } from "@/api/provider/user/user";
const PREFERENCE_KEY = "blackPhotoBackground";
export function useBlackPhotoBackground() {
  const $ = _c(9);
  const userContext = useContext(UserContext);
  const currentUser = userContext?.currentUser;
  const setCurrentUser = userContext?.setCurrentUser;
  let t0;
  if ($[0] !== currentUser) {
    t0 = !!currentUser?.id && hasPermission(currentUser, PERMISSIONS.PATIENTS_NOTES_WRITE);
    $[0] = currentUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isAvailable = t0;
  const isOn = currentUser?.blackPhotoBackground === true;
  let t1;
  if ($[2] !== currentUser || $[3] !== setCurrentUser) {
    t1 = async value => {
      if (!currentUser?.id || !setCurrentUser) {
        return false;
      }
      const userId = currentUser.id;
      const previous = currentUser.blackPhotoBackground;
      setCurrentUser(user => user ? {
        ...user,
        blackPhotoBackground: value
      } : user);
      const result = await patchMyMeta({
        [PREFERENCE_KEY]: value
      });
      if (result === null) {
        setCurrentUser(user_0 => user_0 && user_0.id === userId ? {
          ...user_0,
          blackPhotoBackground: previous
        } : user_0);
        return false;
      }
      return true;
    };
    $[2] = currentUser;
    $[3] = setCurrentUser;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const setOn = t1;
  let t2;
  if ($[5] !== isAvailable || $[6] !== isOn || $[7] !== setOn) {
    t2 = {
      isAvailable,
      isOn,
      setOn
    };
    $[5] = isAvailable;
    $[6] = isOn;
    $[7] = setOn;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}